import validateEmail from './validateEmail'
import validateEnum from './validateEnum'
import validateString from './validateString'
import validateStringDate from './validateStringDate'

type Props = {
  cellValue: string
  fieldType: string
  enumOptions?: string[]
  formats?: string[]
}

const validator = ({ cellValue, fieldType, enumOptions = [], formats = ['yyyy-MM-dd'] }: Props) => {
  switch (fieldType) {
    case 'string':
      return validateString({ string: cellValue })
    case 'date':
      return validateStringDate({ stringDate: cellValue, formats })
    case 'email':
      return validateEmail({ email: cellValue.toLowerCase() })
    case 'enum':
      return validateEnum({ value: cellValue, options: enumOptions })
    default:
      return validateString({ string: cellValue })
  }
}

export default validator
